import BaseForm from '../form-base/base';

document.addEventListener('DOMContentLoaded', () => {
    new BaseForm({
        fromSelector: '[name="request-error"]',
        formSubmitSelector: '[type="submit"]',
        settings: {
            api: 'feedback/report',
        },
    });
});
